import { Component, Input } from '@angular/core';
import { CartSubtotalSettings } from '../widget-preview.types';

const SAMPLE = {
  itemCount: 1,
  totalCents: 2499,
  originalCents: 2999,
};

@Component({
  selector: 'cart-subtotal-preview',
  templateUrl: './cart-subtotal-preview.component.html',
  styleUrls: ['./cart-subtotal-preview.component.scss'],
  standalone: false,
})
export class CartSubtotalPreviewComponent {
  @Input() settings!: CartSubtotalSettings;

  readonly sample = SAMPLE;

  get label(): string {
    const template = this.sample.itemCount === 1 ? this.settings.singleItemLabel : this.settings.multipleItemLabel;
    return (template ?? '').replace(/\{item_count\}/g, String(this.sample.itemCount));
  }

  get formattedTotal(): string {
    return this.formatMoney(this.sample.totalCents);
  }

  get formattedOriginal(): string {
    return this.formatMoney(this.sample.originalCents);
  }

  get hasDiscount(): boolean {
    return this.sample.originalCents > this.sample.totalCents;
  }

  private formatMoney(cents: number): string {
    return `$${(cents / 100).toFixed(2)}`;
  }
}
